import React from "react";
import {
  Bar,
  BarChart,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis
} from "recharts";

import { IChartData } from "../../config/interfaces";
import { UtilService } from "../../services";

type Props = {
	CRChartData: IChartData[];
};

const CompareRegimesChart: React.FC<Props> = (props: Props) => {
	const { CRChartData } = props;

	const CustomLabel = (props: { cx: number; cy: number; value: number }) => {
		const { cx, cy, value } = props;
		const _transform = value >= 0 ? `rotate(-90, ${cx}, ${cy})` : `rotate(90, ${cx}, ${cy})`;
		return (
			<text x={cx} y={cy} fill="#000" fontSize={11} textAnchor="start" transform={_transform}>
				{UtilService.convertToPrice({ price: value })}
			</text>
		);
	};

	const newRegimeCustomLabel = (props: any) => {
		const { x, y, width, value, height } = props;
		// Position label to the right of the bar
		const cx = value >= 0 ? x + width - 43 : x + width - 51;
		// Slight adjustment for vertical alignment
		const cy = y + (value >= 0 ? height - 3 : height + 5);
		return <CustomLabel cx={cx} cy={cy} value={value} />;
	};

	const oldRegimeCustomLabel = (props: any) => {
		const { x, y, width, value, height } = props;
		// Position label to the right of the bar
		const cx = value >= 0 ? x + width + 10 : x + width + 3;
		// Slight adjustment for vertical alignment
		const cy = value >= 0 ? y + height - 3 : y + height + 5;
		return <CustomLabel cx={cx} cy={cy} value={value} />;
	};

	const tooltipFormatter = (value: number) => {
		return UtilService.convertToPrice({ price: value });
	};

	return (
		<ResponsiveContainer width="100%" height={450}>
			<BarChart
				data={CRChartData}
				margin={{
					top: 35,
					right: 30,
					left: 20,
					bottom: 5
				}}
				barSize={40}
				barGap={20}
			>
				<XAxis dataKey="name" />
				<Tooltip formatter={tooltipFormatter} shared={true} trigger="hover" />
				<Legend />
				<ReferenceLine y={0} stroke="#000" />
				<Bar
					label={newRegimeCustomLabel}
					name="New Regime"
					dataKey="NewRegimeValue"
					fill="#5C56D6"
					radius={[5, 5, 0, 0]}
				/>
				<Bar
					label={oldRegimeCustomLabel}
					name="Old Regime"
					dataKey="OldRegimeValue"
					fill="#3CC88A"
					radius={[5, 5, 0, 0]}
				/>
			</BarChart>
		</ResponsiveContainer>
	);
};

export default CompareRegimesChart;
